// 整数部分
export const integerPart = function (value) {
  return parseInt(value);
};

// 小数部分
export const floatPart = function (value, dot) {
  dot = dot || '';
  let transformVal = Number(value).toFixed(2);
  let floatVal = transformVal.substring(transformVal.length - 2);
  return dot + floatVal;
};



// WEBPACK FOOTER //
// ./src/filters/formatNumber.js